/* Hero slideshow.
   Registered against the section registry in hystride-core.js, so it rebinds
   when Ed edits the section in the theme editor and tears its timer down when
   the section is removed. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('hero', {
    mount(root) {
      const slidesEl = root.querySelector('[data-hero-slides]');
      if (!slidesEl) return null;

      // The CSS toggles .on on the <img> itself (.hero-slides img.on), so these
      // are the images, not wrapper elements.
      const slides = Array.from(slidesEl.querySelectorAll('img'));
      const dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
      const foot = root.querySelector('[data-hero-foot]');
      const eyebrow = root.querySelector('[data-hero-eyebrow]');
      const heading = root.querySelector('[data-hero-heading]');
      const cta = root.querySelector('[data-hero-cta]');

      let copy = [];
      try {
        copy = JSON.parse(root.querySelector('[data-hero-copy]').textContent);
      } catch {
        copy = [];
      }

      if (slides.length < 2) return null;

      const speed = parseInt(root.dataset.speed, 10) || 6500;
      const wantsAutoplay = root.dataset.autoplay === 'true';
      let index = 0;
      let timer = null;
      let swapTimer = null;
      let visible = true;

      const paint = (n) => {
        index = (n + slides.length) % slides.length;

        slides.forEach((s, i) => s.classList.toggle('on', i === index));
        dots.forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));

        const c = copy[index];
        if (!c || !foot) return;

        const apply = () => {
          if (eyebrow) eyebrow.textContent = c.eyebrow;
          if (heading) heading.textContent = c.heading;
          if (cta) {
            cta.textContent = c.ctaLabel;
            cta.href = c.ctaLink || '#';
            cta.hidden = !c.ctaLabel;
          }
          foot.classList.add('in');
        };

        if (H.reduceMotion()) {
          apply();
          return;
        }
        // Fade the text out, swap it, fade it back in.
        foot.classList.remove('in');
        clearTimeout(swapTimer);
        swapTimer = setTimeout(apply, 260);
      };

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        // docs/01 §1: the prototype collapses its CSS transitions to 0.001ms
        // under reduced motion but leaves the setInterval running, so the
        // slideshow keeps advancing for someone who asked it not to.
        if (!wantsAutoplay || H.reduceMotion()) return;
        timer = setInterval(() => paint(index + 1), speed);
      };

      // Any interaction restarts the clock, so a slide the visitor just chose
      // does not vanish 100ms later.
      const go = (n) => {
        paint(n);
        start();
      };

      const onDot = (e) => go(parseInt(e.currentTarget.dataset.heroDot, 10));
      const onStep = (e) => go(index + parseInt(e.currentTarget.dataset.heroStep, 10));

      dots.forEach((d) => d.addEventListener('click', onDot));
      const steps = Array.from(root.querySelectorAll('[data-hero-step]'));
      steps.forEach((b) => b.addEventListener('click', onStep));

      // Arrow keys, but only while the hero is actually on screen and no
      // overlay is open. The prototype binds these globally, which hijacks the
      // arrow keys from every other horizontally scrollable element on the page.
      const onKey = (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (document.body.classList.contains('lock')) return;
        if (!visible) return;
        const active = document.activeElement;
        if (active && active.closest('input, textarea, select, [contenteditable]')) return;
        go(index + (e.key === 'ArrowRight' ? 1 : -1));
      };
      document.addEventListener('keydown', onKey);

      let io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(
          ([entry]) => {
            visible = entry.isIntersecting;
            // Do not burn a timer on a slideshow nobody can see.
            visible ? start() : stop();
          },
          { threshold: 0.15 }
        );
        io.observe(root);
      }

      // Swipe. 44px threshold, as in the prototype.
      let startX = null;
      const onTouchStart = (e) => (startX = e.changedTouches[0].clientX);
      const onTouchEnd = (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 44) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      };
      slidesEl.addEventListener('touchstart', onTouchStart, { passive: true });
      slidesEl.addEventListener('touchend', onTouchEnd, { passive: true });

      start();

      return { stop, onKey, dots, steps, slidesEl, onDot, onStep, onTouchStart, onTouchEnd, io };
    },

    unmount(root, s) {
      if (!s) return;
      s.stop();
      document.removeEventListener('keydown', s.onKey);
      s.dots.forEach((d) => d.removeEventListener('click', s.onDot));
      s.steps.forEach((b) => b.removeEventListener('click', s.onStep));
      s.slidesEl.removeEventListener('touchstart', s.onTouchStart);
      s.slidesEl.removeEventListener('touchend', s.onTouchEnd);
      s.io?.disconnect();
    },
  });
})();
